import React from 'react';
import classNames from 'classnames';

import css from './ListingConcludedBanner.module.css';

const CONCLUDED_MESSAGE =
  'This transaction has concluded. Settlement has been executed via non-custodial escrow.';

/**
 * High-visibility overlay for listings in ENDED / ARCHIVED lifecycle state.
 */
const ListingConcludedBanner = props => {
  const { className, lifecycleState } = props;

  return (
    <div
      className={classNames(css.root, className)}
      role="alert"
      data-testid="listing-concluded-banner"
      data-lifecycle-state={lifecycleState}
    >
      <p className={css.title}>Transaction concluded</p>
      <p className={css.body}>{CONCLUDED_MESSAGE}</p>
    </div>
  );
};

export default ListingConcludedBanner;
